module.exports = __webpack_public_path__ + "img/jacobus_07.92fbc3bf.png";